import React from "react";
import { withRouter } from "react-router-dom";
import Register from "~/components/register";

const CheckoutPage = () => {
	return <Register />;
};

export default withRouter(CheckoutPage);
